module.exports = __webpack_public_path__ + "img/7I.6f811285.png";